(() => {
  if (window.__obHomeInitLoaded) return;
  window.__obHomeInitLoaded = true;
  const initOrigenHome = (root) => {
    if (!root || root.dataset.obReady === 'true') return;
    root.dataset.obReady = 'true';

    const tabs = root.querySelectorAll('[data-ob-filter]');
    const cards = root.querySelectorAll('[data-ob-category]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const filter = tab.dataset.obFilter;
        tabs.forEach((item) => {
          item.classList.toggle('is-active', item === tab);
          item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
        });
        cards.forEach((card) => {
          card.hidden = filter !== 'all' && card.dataset.obCategory !== filter;
        });
      });
    });

    root.querySelectorAll('.ob-faq-q').forEach((button) => {
      button.addEventListener('click', () => {
        const item = button.closest('.ob-faq-item');
        const opening = !item.classList.contains('is-open');
        item.classList.toggle('is-open', opening);
        button.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });
    });

    const reveals = root.querySelectorAll('.ob-reveal');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      reveals.forEach((el) => el.classList.add('is-visible'));
    } else {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      reveals.forEach((el) => observer.observe(el));
    }
  };

  document.querySelectorAll('.ob-home').forEach(initOrigenHome);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('.ob-home');
    initOrigenHome(root);
  });
})();
